import logoPoolTonight from "../../assets/logo-pooltonight.png";
import { Headings } from "../../components/Headings";
import PageLayout from "../../components/PageLayout/PageLayout";
import config from "../../config/config.json";
import { SitePage } from "../../types/SitePage";
import "./AboutPage.scss";

const FaqData = [
  {
    question: "How do I find a pool hall?",
    answer:
      "Use the search bar on our map page to find pool halls by name or location.",
  },
  {
    question: "Can I reserve a table through the app?",
    answer:
      "Currently, reservations are handled directly by the pool halls, but we're working on this feature!",
  },
  {
    question: "Is this app free to use?",
    answer: "Yes, PoolTonight is completely free for users.",
  },
  {
    question: "How do I report an issue with a listing?",
    answer:
      "You can report issues by contacting us through the 'Contact Us' link in the app settings or by emailing support@pooltonight.com.",
  },
  {
    question: "Are there any ads in the app?",
    answer: "No, PoolTonight is ad-free to provide the best user experience.",
  },
  {
    question: "Are there leagues or tournaments?",
    answer: "We are currently working on integrating league and tournament information. Stay tuned for updates!"
  }
];

function AboutPage() {
  return (
    <PageLayout page={SitePage.About} title="About">
      <div className="about-page">
        <div className="about-page-content">
          <img
            src={logoPoolTonight}
            alt="PoolTonight Logo"
            className="about-page-logo"
          />
          <Headings.Page>About Us</Headings.Page>
          <p>
            Welcome to PoolTonight! Your go-to app for finding and reserving
            pool tables near you. Whether you're a seasoned shark or a casual
            player, we help you connect with the best spots in town. Dive in and
            discover great places, check table availability, and get ready to
            play!
          </p>
          <a
            href={config.urls.roadmap}
            className="info-box"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Our Roadmap
          </a>

          <Headings.MidPage>Frequently Asked Questions</Headings.MidPage>
          {FaqData.map((item, index) => (
            <div key={`faq-${index}`} className="faq-item">
              <div className="faq-question">{item.question}</div>
              <div className="faq-answer">{item.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}

export default AboutPage;
